import LocationSearch from "@/components/LocationSearch/LocationSearch";
import { UniqueRouteLeg } from "@/hooks/useTransport";
import { DeleteOutlined } from "@ant-design/icons";
import { Button } from "antd";
import styles from "./RouteWizard.module.scss";

export default function ArrivalDepartureLeg({
  leg,
  index,
  updateLeg,
  removeLeg,
  error,
}: {
  leg: UniqueRouteLeg;
  index: number;
  updateLeg: (index: number, leg: UniqueRouteLeg) => void;
  removeLeg: (index: number) => void;
  error: boolean;
}) {
  return (
    <div className={styles.leg}>
      <div className={styles.number}>
        <div className={styles["number-wrapper"]}>{index + 1}</div>
      </div>
      <div className={styles["new-address"]}>
        <LocationSearch
          status={error ? "error" : undefined}
          style={{ flexGrow: 1, maxWidth: 540 }}
          value={leg.address}
          onChange={(value) => updateLeg(index, { ...leg, address: value })}
        />
        <Button
          onClick={() => removeLeg(index)}
          danger
          icon={<DeleteOutlined />}
        />
      </div>
    </div>
  );
}
